import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import cx from "classnames";
import { CheckIcon } from "../../../icons";
import Label from "../Label";
import { toolkitCx } from "../../../constants";
/**
 * A checkbox component that extends the `Checkbox` component from Radix UI.
 *
 * @param {React.ReactNode} label - The label to display alongside the checkbox.
 * @param {string} className - An optional class name to add to the checkbox container.
 * @param {CheckboxPrimitive.CheckboxProps} checkboxRootProps - Additional props to pass to the underlying `Checkbox` component from Radix UI.
 */
const Checkbox = ({ label, className, indeterminate, ...checkboxRootProps }) => {
    const baseClasses = cx("flex h-6 w-6 items-center justify-center", "rounded", toolkitCx.layout.background.default, toolkitCx.layout.background.hoverable, toolkitCx.layout.border.default, toolkitCx.layout.border.weight.default, toolkitCx.layout.text.default, toolkitCx.layout.transition.colors);
    return (_jsxs(_Fragment, { children: [_jsx(CheckboxPrimitive.Root, { ...checkboxRootProps, className: cx(baseClasses, "group", className), children: _jsx(CheckboxPrimitive.Indicator, { children: indeterminate ? "-" : _jsx(CheckIcon, {}) }) }), label && (_jsx(Label, { ...(checkboxRootProps.id && {
                    htmlFor: checkboxRootProps.id,
                }), className: "pl-4", children: label }))] }));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map